import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import * as styles from "./DemoRequestBanner.module.scss"
import { Link } from "gatsby"

const DemoRequestBanner = props => {
  const qwery = props.data
  let bannerClass = ""

  if (qwery.colleagueImage != null || undefined) {
    bannerClass = "lg:w-1/2 lg:text-left lg:mx-4 lg:mb-10"
  } else {
    bannerClass = "lg:w-full lg:text-center lg:mx-4 lg:mb-10 pb-10 lg:pt-0"
  }

  if (qwery.demoRequestText) {
    return (
      <div
        className={
          "text-center pt-10 bg-cover bg-no-repeat lg:mt-32  " + styles.wrapper
        }
        style={{
          backgroundImage:
            "url(https://images.ctfassets.net/rh7phaxwpmak/3X4rrmryB7KQQNLr9G85DT/d7c4d2b37948e4bf5650b1e4a4cd84ae/Skyline.webp)",
        }}
      >
        {/* TODO: add image from Contentful above*/}
        <div className="lg:flex lg:items-center lg:justify-items-start lg:relative lg:h-[300px] lg:max-w-[1140px] lg:mx-auto">
          <div className={bannerClass}>
            <RenderRichContent content={qwery.demoRequestText} />
            {/* TODO: Make button component */}
            <Link
              to={"/" + qwery.demoRequestPage.slug}
              className="px-8 py-4 bg-[#006ef5] text-white rounded-3xl font-semibold font-sans hover:shadow-md hover:bg-[#00469d] transition hover:translate-y-[-1px]"
            >
              {qwery.extraBlocks[0].buttonText}
            </Link>
          </div>
          {qwery.colleagueImage ? (
            <div className="">
              <GatsbyImage
                image={qwery.colleagueImage?.gatsbyImageData}
                className={
                  "max-w-[270px] lg:max-w-[420px] mt-6 lg:absolute lg:bottom-0 lg:right-[134px] " +
                  styles.image
                }
                alt={qwery.colleagueImage?.description === null ? "colleague Image" : qwery.colleagueImage?.description}
              />
              <div className="hidden lg:block lg:absolute lg:top-[-45px] lg:right-0 px-7 py-4 bg-[#0e305d] text-white font-sans rounded-b text-sm shadow-md">
                <span className="block font-bold">{qwery.colleagueName}</span>
                <span>{qwery.colleagueFunctionTitle}</span>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    )
  }

  return <></>
}

export default DemoRequestBanner
